import React, { useEffect, useState } from "react";
import { useLanguage } from "../../languageContext";
import translations from "../../translation.json";
import { toast } from "react-toastify";
import { ApiUrl } from "../../ApiUrl";
import { format, formatDistanceToNow, max, min, parseISO } from "date-fns";
import { usePDF } from "react-to-pdf";
import { internalUsers } from "../../constants/userTypes";
import FilterBar from "../../components/filterBar";

const NewReport = ({
  isDarkMode,
  setDisplayComponent,
  setPrevDisplay,
  setIsLoading,
  isLoading,
  dealerships,
  groups,
}) => {
  const { language } = useLanguage();
  const userType = localStorage.getItem("userType");
  const [eventId, setEventId] = useState(null);
  const [reportData, setEventReportData] = useState(null);
  const [commenttData, setCommentData] = useState("");
  const token = localStorage.getItem("token");
  const { toPDF, targetRef } = usePDF({ filename: "Event-Report.pdf" });
// const { toPDF, targetRef } = usePDF({
//   filename: "Event-Report.pdf",
//   canvas: {
//     windowWidth: 1440,
//   },
// });
  // Filter states
  const [checkedFields, setCheckedFields] = useState([]);
  const [filtersData, setFiltersData] = useState({});
  const [brands, setBrands] = useState([]);
//   const [groups, setGroups] = useState([]);
//   const [dealerships, setDealerships] = useState([]);
  const [filterOption, setFilterOption] = useState("currentYear");

  const allfields = [
    {
      content: translations.quickCreationModal.brand[language],
      name: "brand",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.group[language],
      name: "group",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.quickCreationModal.dealership[language],
      name: "dealership",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.privateEventformFields.startDate[language],
      name: "date_from",
      type: "date",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.privateEventformFields.endDate[language],
      name: "date_to",
      type: "date",
      filterType: "",
      value: "",
    },
  ];

  

  const dealerOptions = dealerships && dealerships.length > 0 ? dealerships.map(dealership => ({
    value: dealership.id,
    label: dealership.name,
  })) : [];

  const groupOptions = groups && groups.length > 0 ? groups.map(group => ({
    value: group.id,
    label: group.name,
  })) : [];

  const brandOptions =
    brands &&
    brands.length > 0 &&
    brands.map((brand) => ({
      value: brand.id,
      label: brand.name,
    }));

  const textOptions = [
    {
      label: translations.commonFields.queryFilters.contain[language],
      value: "like",
    },
    {
      label: translations.commonFields.queryFilters.notContain[language],
      value: "not like",
    },
    {
      label: translations.commonFields.queryFilters.equal[language],
      value: "=",
    },
    {
      label: translations.commonFields.queryFilters.notEqual[language],
      value: "!=",
    },
  ];

  useEffect(() => {
    // Get the current URL
    var currentUrl = window.location.href;
    // Check if '=' is found and extract the text after it
    const equalsIndex = currentUrl.indexOf("=");
    if (equalsIndex !== -1) {
      const secondEqualsIndex = currentUrl.indexOf("=", equalsIndex + 1);

      if (secondEqualsIndex !== -1) {
        const lastParameterValue = currentUrl.substring(secondEqualsIndex + 1);
        setEventId(lastParameterValue);
      }
    }
  });

  useEffect(() => {
    const fetchData = async (filters = {}) => {
      try {
        setIsLoading(true);
        const res = await fetch(ApiUrl + "/api/user/report-with-filter", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            // private_event_id: eventId,
            ...filters,
          }),
        });
        const data = await res.json();
        if (data.status === "success") {
          // const newData = data.private_events.data;
          setEventReportData(data);

          // autoScrollMid();
        } else {
          toast.error(data.message);
        }
      } catch (err) {
        toast.error(translations.alertMessages.wentWrong[language]);
      } finally {
        setIsLoading(false);
      }
    };

    if (token && eventId) {
      fetchData();
    }
  }, [eventId, token]);

  useEffect(() => {
   const getBrands = async () => {
      try {
        const res = await fetch(ApiUrl + "/api/user/get-brands", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (data.status === "success") {
          setBrands(data.list_of_brands);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching dealerships:", error);
        // Handle error or show a toast if needed
      }
    };

    // const getGroups = async () => {
    //   try {
    //     const res = await fetch(ApiUrl + "/api/user/get-groups", {
    //       method: "GET",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${token}`,
    //       },
    //     });
    //     const data = await res.json();
    //     if (data.status === "success") {
    //       setGroups(data.list_of_group);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching groups", error);
    //   }
    // };

    // const getDealerships = async () => {
    //   try {
    //     const res = await fetch(ApiUrl + "/api/user/get-dealerships", {
    //       method: "GET",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${token}`,
    //       },
    //     });
    //     const data = await res.json();
    //     if (data.status === "success") {
    //       setDealerships(data.list_of_dealership);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching dealerships", error);
    //   }
    // };

    if (token) {
      getBrands();
    //   getGroups();
    //   getDealerships();
    }
  }, [token]);

  const getFilteredEvents = async (filterPost) => {
    // Process filterPost to match API expectations
    console.log("filterPost", filterPost)
    const processedFilters = {};
    if (filterPost.dealership_id) {
      processedFilters.dealership_id = filterPost.dealership_id;
    }
    if (filterPost.group_id) {
      processedFilters.group_id = Array.isArray(filterPost.group_id) ? filterPost.group_id: filterPost.group_id;
    }
    // if (filterPost.brand) {
    //   processedFilters.brand = Array.isArray(filterPost.brand) ? filterPost.brand[0] : filterPost.brand;
    // }
      if (filterPost.brand_id) {
          processedFilters.brand_id = Array.isArray(filterPost.brand_id)
              ? filterPost.brand_id
              : filterPost.brand_id;
      }
    if (filterPost.date_from) {
      processedFilters.date_from = Array.isArray(filterPost.date_from) ? filterPost.date_from[0] : filterPost.date_from;
    }
    if (filterPost.date_to) {
      processedFilters.date_to = Array.isArray(filterPost.date_to) ? filterPost.date_to[0] : filterPost.date_to;
    }

    const fetchData = async (filters = {}) => {
      try {
        setIsLoading(true);
        const res = await fetch(ApiUrl + "/api/user/report-with-filter", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            // private_event_id: eventId,
            ...filters,
          }),
        });
        const data = await res.json();
        if (data.status === "success") {
          setEventReportData(data);
        } else {
          toast.error(data.message);
        }
      } catch (err) {
        toast.error(translations.alertMessages.wentWrong[language]);
      } finally {
        setIsLoading(false);
      }
    };

    await fetchData(processedFilters);
  };

  const sendComment = async () => {
    setIsLoading(true);

    try {
      const url = `${ApiUrl}/api/user/event-report-pdf`;
      const bodyData = {
        // private_event_id: eventId,
        comment: commenttData,
      };
      const method = "POST";
      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(bodyData),
      });
      // console.log("res", res)
      const data = await res.json();
      if (data.status === "success") {
        toast.success(data.message);
        setEventReportData({
          ...reportData,
          private_event: {
            ...reportData.private_event,
            comments: [...reportData.private_event.comments, data?.comment],
          },
        });

        setCommentData("");

        // navigate("/event-portal");
        // window.history.back();
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    }
  };

 const getPDF = async () => {
  setIsLoading(true);
  try {
    if (targetRef.current) {
      // Clone the element
      const clone = targetRef.current.cloneNode(true);

      // Position off-screen at fixed desktop width
      clone.style.position = 'fixed';
      clone.style.top = '-9999px';
      clone.style.left = '-9999px';
      clone.style.width = '1200px';
      clone.style.minWidth = '1200px';
      clone.style.padding = '50px 80px';
      clone.style.backgroundColor = '#ffffff';
      clone.style.zIndex = '-1';

      // Add title to clone
      const title = document.createElement('h2');
      title.textContent = language === "en" ? " Global Event Report" : "Rapport global des événements";
      title.style.marginBottom = '20px';
      title.style.padding = '10px 0';
      clone.insertBefore(title, clone.firstChild);

      // Set font size on clone cells
      const cells = clone.querySelectorAll('td, th');
      cells.forEach(cell => {
        cell.style.fontSize = '20px';
      });

      // Attach clone to body
      document.body.appendChild(clone);

      // Wait for reflow
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));

      // Temporarily point targetRef to clone, capture, then restore
      const original = targetRef.current;
      targetRef.current = clone;
      await toPDF();
      targetRef.current = original;

      // Remove clone
      document.body.removeChild(clone);
    }
  } catch (error) {
    toast.error(translations.alertMessages.wentWrong[language]);
  } finally {
    setIsLoading(false);
  }
};
//   const getPDF = async () => {
//     setIsLoading(true);
// //  const res = await fetch(ApiUrl + "/api/user/report-with-filter", {
// //           method: "POST",
// //           headers: {
// //             "Content-Type": "application/json",
// //             Authorization: `Bearer ${token}`,
// //           },
// //           body: JSON.stringify({
// //             // private_event_id: eventId,
// //             ...filters,
// //           }),
// //         });
//  const processedFilters = {};
//     if (filtersData.dealership_id) {
//       processedFilters.dealership_id = filtersData.dealership_id;
//     }
//     if (filtersData.group_id) {
//       processedFilters.group_id = Array.isArray(filtersData.group_id) ? filtersData.group_id : filtersData.group_id;
//     }
//     if (filtersData.brand_id) {
//       processedFilters.brand_id = Array.isArray(filtersData.brand_id) ? filtersData.brand_id : filtersData.brand_id;
//     }
//     if (filtersData.date_from) {
//       processedFilters.date_from = Array.isArray(filtersData.date_from) ? filtersData.date_from[0] : filtersData.date_from;
//     }
//     if (filtersData.date_to) {
//       processedFilters.date_to = Array.isArray(filtersData.date_to) ? filtersData.date_to[0] : filtersData.date_to;
//     }
//     try {
//       const url = `${ApiUrl}/api/user/download-event-report-with-filter`;
//     //   const method = "GET";
//       const res = await fetch(url, {
//         method: "POST",
//        headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//            body: JSON.stringify({
//             // private_event_id: eventId,
//             ...processedFilters,
//           }),
//         responseType: "blob",
//       });
//     //   console.log("res<><>>>>>>>", res)
//       // const data = await res.json();
//       const blob = await res.blob(); // Get the binary data
//       const urlBlob = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = urlBlob;
//       link.setAttribute("download", `${language === 'fr' ? 'Rapports d’événements' : 'Event-Reports'}.pdf`); // Set the file name
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       setIsLoading(false);
//     } catch (error) {
//       setIsLoading(false);
//       toast.error(translations.alertMessages.wentWrong[language]);
//     }
//   };
// console.log("reportData>", brandOptions,groupOptions)
  return (
    <div>
      <FilterBar
        isDarkMode={isDarkMode}
        allfields={allfields}
        checkedFields={checkedFields}
        setCheckedFields={setCheckedFields}
        textOptions={textOptions}
        textOptions2={textOptions}
        filterOption={filterOption}
        setFilterOption={setFilterOption}
        dealerOptions={dealerOptions}
        groupOptions={groupOptions}
        repOptions2={[]}
        managers={[]}
        packageOptions={[]}
        animatorOptions={[]}
        getFilteredEvents={getFilteredEvents}
        filtersData={filtersData}
        setFiltersData={setFiltersData}
        agentOptions={[]}
        monthsList={[]}
        monthTranslations={{}}
        brandOptions={brandOptions}
      />
      <div className="container maincont">
        <div id="app" className="appcountainer2">
          <div className="row align-items-center justify-content-between">
            <div className="col-7 d-flex gap-3 align-items-center">
              <div>
                <h2 id="h1" className={`${isDarkMode ? "darkthead" : ""}`}>
                  {translations.viewEventReport.global_title[language]}
                  {" - "}
                  {reportData?.private_event?.dealer_ship?.name}
                  {": "}
                  {/* {reportData && reportData.prospect_sources.length > 0
                    ? format(
                        max(
                          reportData?.prospect_sources.map((date) =>
                            parseISO(date?.appointment_date)
                          )
                        ), // Convert to Date objects
                        "dd/MM/yyyy"
                      )
                    : "N/A"}{" "} */}
                  {reportData?.private_event?.start_date}{" "}
                  {translations.commonWords.to[language]}{" "}
                  {reportData?.private_event?.end_date}
                  {/* {reportData && reportData.prospect_sources.length > 0
                    ? format(
                        min(
                          reportData.prospect_sources?.map((date) =>
                            parseISO(date?.appointment_date)
                          )
                        ), // Convert to Date objects
                        "dd/MM/yyyy"
                      )
                    : "N/A"} */}
                </h2>
              </div>
            </div>
            <div className="col-5 gap-1 d-flex align-items-center justify-content-end">
              <div
                className="btn-group"
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  className="btn admin-btn btn-primary"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#filtersidebar"
                  aria-bs-controls="#filtersidebar"
                >
                  <i className="bi bi-search"></i>{" "}
                  {translations.commonWords.search[language]}
                </button>
              </div>
              {/* <div
                className="btn-group"
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  className="btn admin-btn btn-primary"
                  // data-bs-toggle="modal"
                  // data-bs-target="#modalQuickAdd"
                  // fdprocessedid="2rud2c"
                  onClick={() => {
                    setDisplayComponent("event-view");

                    window.history.pushState(
                      {
                        id: "gallery",
                        randomData: window.Math.random(),
                      },
                      "title",
                      "/event-portal?page=event-view&event_id=" + eventId
                    );
                  }}
                >
                  <i className="bi bi-speedometer"></i>{" "}
                  {translations.eventView.buttons.dashboard[language]}
                </button>
              </div>
              <div
                className="btn-group"
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  className="btn admin-btn btn-primary"
                  onClick={() => {
                    setDisplayComponent("appointments");

                    window.history.pushState(
                      {
                        id: "gallery",
                        randomData: window.Math.random(),
                      },
                      "title",
                      `/event-portal?page=appointments&eventId=${eventId}`
                    );
                  }}
                >
                  <i className="bi bi-calendar2-range"></i>{" "}
                  {translations.eventView.buttons.calender[language]}
                </button>
              </div>
              <div
                className="btn-group"
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  className="btn admin-btn btn-primary"
                  // data-bs-toggle="modal"
                  // data-bs-target="#modalQuickAdd"
                  // fdprocessedid="2rud2c"
                  onClick={() => {
                    setDisplayComponent("clients");

                    window.history.pushState(
                      {
                        id: "gallery",
                        randomData: window.Math.random(),
                      },
                      "title",
                      `/event-portal?page=clients&eventId=${eventId}`
                    );
                  }}
                >
                  <i className="bi bi-people"></i>{" "}
                  {translations.forms.formFields.clients[language]}
                </button>
              </div>
              <div
                className="btn-group d-flex align-items-center gap-1"
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  className="btn admin-btn btn-primary d-flex align-items-center gap-1"
                  // data-bs-toggle="modal"
                  // data-bs-target="#modalQuickAdd"
                  // fdprocessedid="2rud2c"
                  onClick={() => {
                    setDisplayComponent("copy-client");

                    window.history.pushState(
                      {
                        id: "gallery",
                        randomData: window.Math.random(),
                      },
                      "title",
                      `/event-portal?page=copy-client&eventId=${eventId}`
                    );
                  }}
                >
                  <i className="bi bi-clipboard-plus"></i>{" "}
                  {translations.forms.formFields.copyClient[language]}
                </button>
              </div>
              <div
                className="btn-group"
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  //   className="btn admin-btn btn-primary"
                  // data-bs-toggle="modal"
                  // data-bs-target="#modalQuickAdd"
                  // fdprocessedid="2rud2c"
                  style={{
                    background: "#05cc9e",
                    // color: "white",
                    paddingBlock: "0.375rem",
                    paddingInline: "0.75rem",
                    borderRadius: "0.375rem",
                    borderColor: "#05cc9e",
                    borderStyle: "solid",
                  }}
                >
                  <i className="bi bi-file-earmark-bar-graph"></i>{" "}
                  {translations.viewEventReport.title[language]}
                </button>
              </div> */}
                 <div className="">
              {" "}
              {reportData && reportData?.prospect_sources.length > 0 && (
                <button
                  type="button"
                  className="admin-btn d-flex align-items-center gap-2"
                  onClick={getPDF}
                >
                  <i className="bi bi-download"></i>
                  {translations.commonWords.downloadPDF[language]}{" "}
                </button>
              )}
            </div>
            </div>
          </div>
          <div ref={targetRef}>
          {/* {
            console.log("reportData", reportData)
          } */}
          <div className="my-2 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center flex-wrap gap-4 ">
              <h5 id="h1" className={``}>
                Client {": "} {reportData?.totals?.clients}
              </h5>
              <h5 id="h1" className={``}>
                {translations.forms.conquestBtn[language]} {": "}{" "}
                {reportData?.totals?.conquest}
              </h5>
              <h5 id="h1" className={``}>
                {translations.forms.formFields.inactive[language]} {": "}{" "}
                {reportData?.totals?.inactive}
              </h5>
            </div>
            {/* <div className="">
              {" "}
              {reportData && reportData?.prospect_sources.length > 0 && (
                <button
                  type="button"
                  className="admin-btn d-flex align-items-center gap-2"
                  onClick={getPDF}
                >
                  <i className="bi bi-download"></i>
                  {translations.commonWords.downloadPDF[language]}{" "}
                </button>
              )}
            </div> */}
          </div>
          {!isLoading && (
            <div className="row">
              <div
                className={`${
                  userType && internalUsers.includes(userType)
                    ? "col-12"
                    : "col-12"
                }`}
                // style={{
                //   display: "flex",
                //   flexDirection: "column",
                //   justifyContent: "space-between",
                // }}
                // ref={containerRef}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  overflowX: "auto",
                  //   justifyContent: "space-between",
                  // height: "calc(100vh - 260px)",
                }}
              >
                {reportData && reportData?.prospect_sources.length > 0 ? (
                  <>
                    <table
                      className={`table table-hover text-center align-middle reportTable`}
                    >
                      <thead
                        style={{ position: "sticky", top: "0", zIndex: "1" }}
                      >
                        <tr>
                          <th
                            scope="col"
                            className={`${isDarkMode ? "darkthead" : ""}`}
                            style={{
                              width: "50%",
                              textAlign: "start",
                            }}
                          >
                            {
                              translations.eventReport2.appointmentSource[
                                language
                              ]
                            }
                          </th>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <th
                                scope="col"
                                className={`${isDarkMode ? "darkthead" : ""}`}
                                style={{
                                  minWidth:
                                    language === "en" ? "125px" : "150px",
                                  width: "10%",
                                }}
                              >
                                {item?.appointment_date}
                              </th>
                            ))} */}

                          {/* <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "135px" : "195px",
                      }}
                    >
                      {translations.clients.table.noShowStatus[language]}
                    </th> */}
                          <th
                            scope="col"
                            // colSpan={2}
                            className={`${isDarkMode ? "darkthead" : ""}`}
                            style={{
                              width: "50%",
                              textAlign: "start",
                            }}
                          >
                            Total
                          </th>
                          {/* <th scope="col"></th> */}
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">Fidgi</td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.one_Fidgi_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.one_Fidgi_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {
                              translations.commonWords.usersTypes.animator[
                                language
                              ]
                            }
                          </td>

                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.one_Animator_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum +
                                  (Number(event?.one_Animator_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {translations.forms.conquestBtn[language]}
                          </td>

                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.one_Conquest_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum +
                                  (Number(event?.one_Conquest_count) || 0),
                                0
                              )}
                          </td>
                        </tr>

                        {/* Walk-in/BB and Dealership moved under Confirmed Appointments (not counted in Total) */}

                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">Web-Fidgi</td>

                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.one_Web_Fidgi}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.one_Web_Fidgi) || 0),
                                0
                              )}
                          </td>
                        </tr>

                        <tr style={{textAlign:'start'}}>
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {
                              translations.eventReport2.totalAppointments[
                                language
                              ]
                            }
                          </td>

                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td
                                className="dlrname text-white"
                                style={{
                                  //   borderBottom: "1px solid #dee2e6",
                                  background: `${
                                    isDarkMode ? "#435574" : "#435574"
                                  }`,
                                }}
                              >
                                {item?.one_total_count}{" "}
                              </td>
                            ))} */}

                          <td
                            className="dlrname text-white"
                            style={{
                              background: `${isDarkMode ? "#435574" : "#435574"}`,
                            }}
                          >
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce((sum, event) => {
                                const total = Number(event?.one_total_count) || 0;
                                const walkin = Number(event?.one_Walk_in) || 0;
                                const dealership = Number(event?.one_Dealership) || 0;
                                return sum + (total - walkin - dealership);
                              }, 0)}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {
                              translations.eventReport2.appointmentsConfirmed[
                                language
                              ]
                            }
                          </td>
{/* 
                          {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td
                                className="dlrname text-white"
                                style={{
                                  //   borderBottom: "1px solid #dee2e6",
                                  background: `${
                                    isDarkMode ? "#435574" : "#435574"
                                  }`,
                                }}
                              >
                                {item?.confirmed_count}{" "}
                              </td>
                            ))} */}

                          <td
                            className="dlrname text-white"
                            style={{
                              background: `${isDarkMode ? "#435574" : "#435574"}`,
                            }}
                          >
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.confirmed_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{ textAlign: "start" }}>
                          <td className="dlrname">Walk-in/BB </td>
                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) => sum + (Number(event?.one_Walk_in) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{ textAlign: "start" }}>
                          <td className="dlrname">{translations.commonWords.dealership[language]}</td>
                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) => sum + (Number(event?.one_Dealership) || 0),
                                0
                              )}
                          </td>
                        </tr>
                      </tbody>
                    </table>



                    <table className="table table-hover text-center align-middle mt-4 reportTable">
                      <thead
                        style={{ position: "sticky", top: "0", zIndex: "1" }}
                      >
                        <tr>
                          <th
                            scope="col"
                            className={`${isDarkMode ? "darkthead" : ""}`}
                            style={{
                              width: "50%",
                              textAlign: 'start'
                            }}
                          >
                            {translations.eventReport2.presenceSource[language]}
                          </th>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <th
                                scope="col"
                                className={`${isDarkMode ? "darkthead" : ""}`}
                                style={{
                                  minWidth:
                                    language === "en" ? "125px" : "150px",
                                  width: "10%",
                                }}
                              >
                                {item?.appointment_date}
                              </th>
                            ))} */}
                          <th
                            scope="col"
                            // colSpan={2}
                            className={`${isDarkMode ? "darkthead" : ""}`}
                            style={{
                              width: "50%",
                              textAlign:'start'
                            }}
                          >
                            Total
                          </th>
                          {/* <th scope="col"></th> */}
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">Fidgi</td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.two_Fidgi_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.two_Fidgi_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {
                              translations.commonWords.usersTypes.animator[
                                language
                              ]
                            }
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.two_Animator_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum +
                                  (Number(event?.two_Animator_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {translations.forms.conquestBtn[language]}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.two_Conquest_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum +
                                  (Number(event?.two_Conquest_count) || 0),
                                0
                              )}
                          </td>
                        </tr>

                        {/* Walk-in/BB and Dealership moved under Présence (en %) and excluded from Total Fidgi */}

                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">Web-Fidgi</td>

                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.two_Web_Fidgi}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.two_Web_Fidgi) || 0),
                                0
                              )}
                          </td>
                        </tr>

                        <tr style={{textAlign:'start'}}>
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {/* {translations.eventReport2.totalAppointments[language]} */}
                            Total Fidgi
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td
                                className="dlrname text-white"
                                style={{
                                  //   borderBottom: "1px solid #dee2e6",
                                  background: `${
                                    isDarkMode ? "#435574" : "#435574"
                                  }`,
                                }}
                              >
                                {item?.two_t_count}{" "}
                              </td>
                            ))} */}
                          <td
                            className="dlrname text-white"
                            style={{
                              background: `${isDarkMode ? "#435574" : "#435574"}`,
                            }}
                          >
                            {/* {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce((sum, event) => {
                                const total = Number(event?.two_t_count) || 0;
                                const walkin = Number(event?.two_Walk_in) || 0;
                                const dealership = Number(event?.two_Dealership) || 0;
                                return sum + (total - walkin - dealership);
                              }, 0)} */}
                              {reportData &&
                                reportData.prospect_sources &&
                                reportData.prospect_sources.length > 0 &&
                                reportData.prospect_sources.reduce(
                                  (sum, event) => sum + (Number(event?.two_t_count) || 0),
                                  0
                                )}
                          </td>
                        </tr>

                        <tr style={{textAlign:'start'}}>
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {translations.eventReport2.presenceIn[language]}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td
                                className="dlrname text-white"
                                style={{
                                  //   borderBottom: "1px solid #dee2e6",
                                  background: `${
                                    isDarkMode ? "#435574" : "#435574"
                                  }`,
                                }}
                              >
                                {Number(
                                  item?.percentage_of_appointment_total
                                ).toFixed(2)}
                                {"% "}
                              </td>
                            ))} */}

                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 && (
                                <>
                                  {(() => {
                                      const totalFidgi = reportData.prospect_sources.reduce(
                                        (sum, event) =>
                                          sum + (Number(event?.two_t_count) || 0),
                                        0
                                      );
                                      // const totalWalkin = reportData.prospect_sources.reduce(
                                      //   (sum, event) => sum + (Number(event?.two_Walk_in) || 0),
                                      //   0
                                      // );
                                      // const totalDealership = reportData.prospect_sources.reduce(
                                      //   (sum, event) => sum + (Number(event?.two_Dealership) || 0),
                                      //   0
                                      // );
                                      // const confirmed = reportData.prospect_sources.reduce(
                                      //   (sum, event) => sum + (Number(event?.confirmed_count) || 0),
                                      //   0
                                      // );
                                      // const confirmedWalkin = reportData.prospect_sources.reduce(
                                      //   (sum, event) => sum + (Number(event?.one_Walk_in) || 0),
                                      //   0
                                      // );
                                      // const confirmedDealership = reportData.prospect_sources.reduce(
                                      //   (sum, event) => sum + (Number(event?.one_Dealership) || 0),
                                      //   0
                                      // );
                                      // const numerator = totalFidgi - totalWalkin - totalDealership;
                                      // const denominator = confirmed - confirmedWalkin - confirmedDealership;
                                      // if (!denominator) return "0.00";
                                      // return ((numerator / denominator) * 100).toFixed(2);
                                       const confirmed = reportData.prospect_sources.reduce(
                                        (sum, event) => sum + (Number(event?.confirmed_count) || 0),
                                        0
                                      );
                                       if (!confirmed) return "0.00";
                                      return ((totalFidgi / confirmed) * 100).toFixed(2);
                                    })()}
                                  %
                                </>
                              )}
                          </td>
                        </tr>

                        <tr style={{textAlign:'start'}}>
                          <td
                            className="dlrname text-white"
                            style={{
                              background: `${isDarkMode ? "#435574" : "#435574"}`,
                            }}
                          >
                            Walk-in/BB 
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td
                                className="dlrname text-white"
                                style={{
                                  //   borderBottom: "1px solid #dee2e6",
                                  background: `${
                                    isDarkMode ? "#435574" : "#435574"
                                  }`,
                                }}
                              >
                                {item?.Walk_in_count}{" "}
                              </td>
                            ))} */}

                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.two_Walk_in) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td
                            className="dlrname text-white"
                            style={{
                              background: `${isDarkMode ? "#435574" : "#435574"}`,
                            }}
                          >
                            {translations.commonWords.dealership[language]}
                          </td>
                          <td
                            className="dlrname text-white"
                            style={{
                              background: `${isDarkMode ? "#435574" : "#435574"}`,
                            }}
                          >
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) => sum + (Number(event?.two_Dealership) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {translations.eventReport2.totalPresences[language]}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td
                                className="dlrname text-white"
                                style={{
                                  //   borderBottom: "1px solid #dee2e6",
                                  background: `${
                                    isDarkMode ? "#435574" : "#435574"
                                  }`,
                                }}
                              >
                                {item?.two_total_count}{" "}
                              </td>
                            ))} */}

                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.two_total_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table className="table table-hover text-center align-middle mt-4 reportTable">
                      <thead
                        style={{ position: "sticky", top: "0", zIndex: "1" }}
                      >
                        <tr>
                          <th
                            scope="col"
                            className={`${isDarkMode ? "darkthead" : ""}`}
                            style={{
                              width: "50%",
                              textAlign: 'start'
                            }}
                          >
                            {translations.eventReport2.salesSource[language]}
                          </th>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <th
                                scope="col"
                                className={`${isDarkMode ? "darkthead" : ""}`}
                                style={{
                                  minWidth:
                                    language === "en" ? "125px" : "150px",
                                  width: "10%",
                                }}
                              >
                                {item?.appointment_date}
                              </th>
                            ))} */}
                          {/* <th
                      scope="col"
                      className={`${isDarkMode ? "darkthead" : ""}`}
                      style={{
                        minWidth: language === "en" ? "135px" : "195px",
                      }}
                    >
                      {translations.clients.table.noShowStatus[language]}
                    </th> */}
                          <th
                            scope="col"
                            // colSpan={2}
                            className={`${isDarkMode ? "darkthead" : ""}`}
                            style={{
                              width: "50%",
                              textAlign:'start'
                            }}
                          >
                            Total
                          </th>
                          {/* <th scope="col"></th> */}
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {translations.eventReport2.newFidgi[language]}{" "}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.new_fidgi_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.new_fidgi_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {translations.eventReport2.usedFidgi[language]}{" "}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.use_fidgi_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.use_fidgi_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {translations.eventReport2.newAnimator[language]}{" "}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.new_animator_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum +
                                  (Number(event?.new_animator_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {translations.eventReport2.usedAnimator[language]}{" "}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.use_animator_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum +
                                  (Number(event?.use_animator_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {translations.eventReport2.newConquest[language]}{" "}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.new_conquest_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum +
                                  (Number(event?.new_conquest_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {translations.eventReport2.usedConquest[language]}{" "}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.use_conquest_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum +
                                  (Number(event?.use_conquest_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {translations.eventReport2.newDealership[language]}{" "}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.new_dealership}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.new_dealership) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {translations.eventReport2.usedDealership[language]}{" "}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.use_dealership}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.use_dealership) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {translations.eventReport2.newWalkIn[language]}{" "}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.new_Walk_in_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.new_Walk_in_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td className="dlrname">
                            {translations.eventReport2.usedWalkIn[language]}{" "}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.use_Walk_in_count}{" "}
                              </td>
                            ))} */}

                          <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.use_Walk_in_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {translations.eventReport2.totalNew[language]}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td
                                className="dlrname text-white"
                                style={{
                                  //   borderBottom: "1px solid #dee2e6",
                                  background: `${
                                    isDarkMode ? "#435574" : "#435574"
                                  }`,
                                }}
                              >
                                {item?.new_used_count}{" "}
                              </td>
                            ))} */}
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.new_used_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {translations.eventReport2.totalUsed[language]}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td
                                className="dlrname text-white"
                                style={{
                                  //   borderBottom: "1px solid #dee2e6",
                                  background: `${
                                    isDarkMode ? "#435574" : "#435574"
                                  }`,
                                }}
                              >
                                {item?.use_used_count}{" "}
                              </td>
                            ))} */}
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.use_used_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        <tr style={{textAlign:'start'}}>
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {translations.eventReport2.totalSales[language]}
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td
                                className="dlrname text-white"
                                style={{
                                  //   borderBottom: "1px solid #dee2e6",
                                  background: `${
                                    isDarkMode ? "#435574" : "#435574"
                                  }`,
                                }}
                              >
                                {item?.total_new_used_count}{" "}
                              </td>
                            ))} */}
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum +
                                  (Number(event?.total_new_used_count) || 0),
                                0
                              )}
                          </td>
                        </tr>
                        {/* <tr style={{textAlign:'start'}}> */}
                          {/* <td className="dlrname">
                            {translations.eventReport2.noShow[language]}{" "}
                          </td> */}
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td className="dlrname">
                                {item?.no_show_count}{" "}
                              </td>
                            ))} */}
                          {/* <td className="dlrname">
                            {reportData &&
                              reportData.prospect_sources &&
                              reportData.prospect_sources.length > 0 &&
                              reportData.prospect_sources.reduce(
                                (sum, event) =>
                                  sum + (Number(event?.no_show_count) || 0),
                                0
                              )}
                          </td> */}
                        {/* </tr> */}
                        <tr style={{textAlign:'start'}}>
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            {
                              translations.eventReport2.closinginPersent[
                                language
                              ]
                            }
                          </td>
                          {/* {reportData &&
                            reportData.prospect_sources &&
                            reportData.prospect_sources.length > 0 &&
                            reportData.prospect_sources.map((item, index) => (
                              <td
                                className="dlrname text-white"
                                style={{
                                  //   borderBottom: "1px solid #dee2e6",
                                  background: `${
                                    isDarkMode ? "#435574" : "#435574"
                                  }`,
                                }}
                              >
                                {Number(item?.new_used_percentage).toFixed(2)}
                                {"% "}
                              </td>
                            ))} */}
                          <td
                            className="dlrname text-white"
                            style={{
                              //   borderBottom: "1px solid #dee2e6",
                              background: `${
                                isDarkMode ? "#435574" : "#435574"
                              }`,
                            }}
                          >
                            <>
                              {(
                                (reportData?.prospect_sources.reduce(
                                  (sum, event) =>
                                    sum +
                                    (Number(event?.total_new_used_count) || 0),
                                  0
                                ) /
                                  reportData?.prospect_sources.reduce(
                                    (sum, event) =>
                                      sum +
                                      (Number(event?.two_total_count) || 0),
                                    0
                                  )) *
                                100
                              ).toFixed(2)}
                              %
                            </>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                ) : (
                  <div className="d-flex justify-content-center py-4">
                    <h4>{translations.EventsPortal.noDataMessage[language]}</h4>
                  </div>
                )}
              </div>
              
            </div>
          )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewReport;
